var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex gap-6 text-sm font-bold text-grey-700",attrs:{"id":"golive-radio"}},_vm._l((_vm.options),function(i,index){return _c('div',{key:index,class:[
      'h-full cursor-pointer bg-grey-200 flex place-items-center justify-center hover:bg-indigo-300 hover:text-white',
      {
        active: _vm.selectedItems.includes(i.value),
      } ],staticStyle:{"width":"100px"},on:{"click":function($event){return _vm.onSelect(i.value)}}},[_vm._v(" "+_vm._s(i.label)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }